import React, { useEffect, useState } from 'react';
import { Button, FormControl, FormControlLabel, FormGroup, FormLabel, Checkbox, Select, Input, MenuItem, Box, Icon, Stack } from '@mui/material';
import { DatePicker } from 'global/components/date-picker'
import HomeIcon from '@mui/icons-material/Home';
import FilterIcon from '@mui/icons-material/FilterList';
import { CommunityIcon, DivisionIcon } from 'global/components/PerformIcons';
import { useSelector, useDispatch } from 'react-redux';
import { get, set, size, isArray, xor, uniqBy } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import { AssessmentFilter, FILTERDEFAULTS } from 'global/utils/filter';
import {
  FilterRow,
  filterFormGridSx,
  filterFormItemSx,
  filterFormLabelSx,
  filterFormControlPaddingSx,
  filterDatePickerPaddingSx,
  filterIconSx,
  filterCheckRowSx,
  filterCheckIconSx,
  filterLinkTextSx,
  filterCompareRowSx,
  filterCompareCloseSx,
  filterHiddenSx,
} from 'global/styles/filters';
import { useScreen } from 'global/styles';
import DiagContainer from 'global/components/diag-container';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { sortAlphaNum, cleanCopy } from 'global/utils';
import { FilterChips } from 'global/components/filterchips';
import { QualityType, RealmTypes, HighlightSectionType, HighlightTemplate } from 'global/lib/filter';
import { CompareTypes, DateRanges, ReportDataStatus } from '../../../global/lib/filter';
import { Text } from '../../../global/components/text';
import { Row } from '../../../global/components/row';
import { useFilter } from '../../../global/hooks/useFilter';
import Droprealms from '../../../global/components/droprealms';
import { useUser } from '../../../global/hooks/useUser';
import { ensureArray } from '../../../global/utils';
import { IconButton } from '../../../global/components/Button';

const ICONS = {
  HomeIcon,
  CommunityIcon,
  DivisionIcon,
};

export default function PerformReportsFilters(props) {
  const { display } = props;
  const vendors = get(props, 'vendors');
  const [showFilters, setShowFilters] = useState(false);
  const useInternalFilter = !!props.filter;
  const filter = useSelector((state) => (useInternalFilter ? props.filter : get(state, `filter.reports.${display}`, AssessmentFilter())));
  const dispatch = useDispatch();
  const [intFilter, setIntFilter] = useState(filter);
  const fhook = useFilter();
  const thefilter = useInternalFilter ? intFilter : filter;
  const { realm_type, start_date, end_date, scorecard_id, superset_id, user_id, quality_type, status, edition_id, daterange, _showCompare, template_id, section_type, template, _photoSource } = thefilter;

  const [state, setState] = useState({
    useExact: false,
    currentRealm: null,
  });
  const user = useUser();

  const realms = get(thefilter, 'realms', []);

  const editions = useRetrieveData(
    { url: '/editions' },
    {
      useEffect: true,
      waitFor: display === 'data',
      params: {
        filter: {
          latest: 1,
        },
      },
      build: ['editions'],
      useCache: { reload: 20, store: `data.latesteditions` },
    }
  );

  const scorecards = useRetrieveData(
    { url: '/scorecards' },
    {
      build: ['scorecards'],
      useCache: { reload: 20, store: 'data.scorecards' },
      params: {
        include: 'realms',
      },
    }
  );
  const templates = useRetrieveData(
    { url: '/assessment-templates' },
    {
      build: ['assessments'],
      useCache: { reload: 20, store: 'data.assessmentTemplates' },
      params: {
        filter: { accessible_templates: 1 }
      },
    }
  );

  const content_realm_id = get(user.me, 'realm.id');
  const users = useRetrieveData(
    { url: '/users' },
    {
      waitFor: display === 'photo' ? undefined : null,
      build: ['users'],
      params: {
        filter: content_realm_id && {
          content_realm_id,
        },
      },
      useCache: { reload: 1 },
    }
  );
  const supersets = useRetrieveData(
    { url: '/supersets' },
    {
      build: ['supersets'],
      useCache: { reload: 20 },
    }
  );

  const prefixToUse = 'vendor';

  const { isMobile } = useScreen();

  useEffect(() => {
    setShowFilters(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const amt = size([start_date, end_date].filter((f) => !!f));
    if (amt == 1 && !state.useExact) {
      setState((s) => ({ ...s, useExact: true }));
    } else if (amt == 0 && state.useExact) {
      setState((s) => ({ ...s, useExact: false }));
      handleDatesChange({ target: { value: 'all' } });
    }
  }, [filter]);

  useEffect(() => {
    if (useInternalFilter) {
      return;
    }
    if (!state.currentRealm && fhook.user.realm) {
      setState((s) => ({ ...s, currentRealm: fhook.user.realm }));
    }
    changeFilter(set({ ...filter }, 'realms', [...ensureArray(get(fhook, 'user.realm', []) || [])]));
  }, [fhook.user.realm]);

  const changeFilter = (filt) => {
    if (useInternalFilter) {
      const val = { ...filt };
      setIntFilter(val);
      props.onChange && props.onChange(val);
    } else {
      dispatch(setFilter('reports', display, filt));
    }
  };

  function handleStartDateChange(date) {
    const filt = { ...filter };
    set(filt, `start_date`, date);
    set(filt, 'daterange', 'all');
    changeFilter(filt);
  }

  function handleEndDateChange(date) {
    const filt = { ...filter };
    set(filt, `end_date`, date);
    set(filt, 'daterange', 'all');
    changeFilter(filt);
  }

  function handleDatesChange(e) {
    const val = e.target.value;
    const res = DateRanges.find((d) => d.value == val);
    const filt = { ...filter };
    get(res, 'vals', []).map((v, i) => {
      set(filt, i === 0 ? 'start_date' : 'end_date', v);
    });
    set(filt, 'daterange', val);
    changeFilter(filt);
  }

  function handleScorecardChange(e) {
    changeFilter(set({ ...filter }, `scorecard_id`, e.target.value));
  }

  function handleTemplateChange(e) {
    changeFilter(set({ ...filter }, `template_id`, e.target.value));
  }

  function handleEditionChange(e) {
    changeFilter(set({ ...filter }, `edition_id`, e.target.value));
  }

  function handleSystemChange(e) {
    changeFilter(set({ ...filter }, `superset_id`, e.target.value));
  }

  function handleAuthorChange(e) {
    changeFilter(set({ ...filter }, `user_id`, e.target.value));
  }

  function handleQualityChange(e) {
    changeFilter(set({ ...filter }, `quality_type`, e.target.value));
  }

  function handleSectionTypeChange(e) {
    const val = e.target.value;
    changeFilter(set({ ...filter }, 'section_type', val === '' ? null : val));
  }

  function handleHighlightTemplateChange(e) {
    const val = e.target.value;
    changeFilter(set({ ...filter }, 'template', val === '' ? null : Number(val)));
  }

  const handleRealmType = (e, val) => {
    changeFilter(set({ ...filter }, `realm_type`, xor(realm_type, [val])));
  };

  const handleVendorChange = (e) => {
    const vend = get(vendors, 'data', []).find((v) => v.id == e.target.value);
    changeFilter(set({ ...filter }, `${prefixToUse}_id`, get(vend, `${prefixToUse}Id`, null)));
  };

  const handleStatusChange = (e) => {
    changeFilter(set({ ...filter }, 'status', e.target.value));
  };

  function toggleFilters() {
    setShowFilters(!showFilters);
  }

  function clearFilters() {
    changeFilter(cleanCopy(get(FILTERDEFAULTS, `reports.${display}`, AssessmentFilter())));
    setState((s) => ({ ...s, useExact: false }));
  }

  function updateRealms(selRealms) {
    changeFilter(
      set(
        { ...filter },
        'realms',
        Object.keys(selRealms).map((r) => selRealms[r])
      )
    );
  }

  const canShowFilter = (f) => {
    if (props.onlyFilters) {
      return props.onlyFilters.includes(f);
    } else {
      return true;
    }
  };

  const toggleCompare = () => {
    if (useInternalFilter) {
      const showCompare = !_showCompare;
      return changeFilter({ ...filter, _showCompare: showCompare })
    }

    const showCompare = !_showCompare;
    dispatch(setFilter('reports', display, { ...filter, _showCompare: showCompare }));

    if (!showCompare) {
      dispatch(setFilter('reports', display, { ...filter, compareStatus: 'active', compareType: 'diff', _showCompare: showCompare }));
    }
  }

  const hasVendors = size(get(vendors, 'data')) > 0;
  const client = get(vendors, 'data', []).find((v) => get(v, [prefixToUse, 'id']) == get(filter, `${prefixToUse}_id`));
  const allrealms = uniqBy(
    realms.filter((f) => !!f),
    'id'
  );

  const scorecards_data = fhook.filterScorecards(scorecards.data);

  return (
    <Box sx={{
      displayPrint: 'none'
    }}>
      {isMobile && (
        <FilterRow isMobile>
          <Button aria-label="filters" size="small" onClick={toggleFilters}>
            <FilterIcon fontSize="inherit" sx={filterIconSx} /> {'Filters'}
          </Button>
          {/* Data shows realm via Droprealms `realms` chips; list/photo need the global picker chip. */}
          <FilterChips id={`reports.${display}`} includeRealm={display !== 'data'} />
        </FilterRow>
      )}
      <DiagContainer useDialog={isMobile} title="Filters" onClose={toggleFilters} onClear={clearFilters} open={showFilters}>
        <form autoComplete="off" margin="normal" style={!showFilters ? filterHiddenSx : undefined}>
          <Stack spacing={1} direction={props.asRow ? (isMobile ? 'column' : 'row') : 'column'}>
            {display === 'data' && canShowFilter('edition') && (
              <Box sx={filterFormGridSx}>
                <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                  <FormLabel htmlFor="Standard-scorecard-simple" sx={filterFormLabelSx}>
                    Edition
                  </FormLabel>
                  <Select value={edition_id} onChange={handleEditionChange} input={<Input name="scorecard" id="Standard-scorecard-simple" />}>
                    <MenuItem value={0}>
                      <em>Any</em>
                    </MenuItem>
                    {size(editions.data) &&
                      editions.data.map((card, i) => {
                        return (
                          <MenuItem key={`${card.id}-${i}`} value={card.id}>
                            {card.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Box>
            )}

            {canShowFilter('scorecard') && (
              <Box sx={filterFormGridSx}>
                <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                  <FormLabel htmlFor="Standard-scorecard-simple" sx={filterFormLabelSx}>
                    Scorecard
                  </FormLabel>
                  <Select value={scorecard_id} onChange={handleScorecardChange} input={<Input name="scorecard" id="Standard-scorecard-simple" />}>
                    <MenuItem value={0}>
                      <em>Any</em>
                    </MenuItem>
                    {size(scorecards_data) &&
                      scorecards_data.map((card, i) => {
                        return (
                          <MenuItem key={`${card.id}-${i}`} value={card.id}>
                            {card.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Box>
            )}

            {canShowFilter('location') && (
              <Box sx={filterFormGridSx}>
                <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                  <FormLabel sx={filterFormLabelSx}>{'Assigned Location Level'}</FormLabel>
                  <FormGroup>
                    {RealmTypes.map((rt, i) => {
                      const ICO = ICONS[rt.icon];
                      return (
                        <FormControlLabel
                          key={i}
                          control={<Checkbox checked={isArray(realm_type) && realm_type.includes(rt.value)} onChange={(e) => handleRealmType(e, rt.value)} value={rt.value} />}
                          label={
                            <Box sx={filterCheckRowSx}>
                              <ICO sx={filterCheckIconSx} />
                              {rt.title}
                            </Box>
                          }
                        />
                      );
                    })}
                  </FormGroup>
                </FormControl>
              </Box>
            )}

            {canShowFilter('startDate') && (
              <Box sx={filterFormGridSx}>
                <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                  <Row spaceBetween dontCenter>
                    <FormLabel htmlFor="Standard-scorecard-simple" sx={filterFormLabelSx}>
                      Date
                    </FormLabel>
                    <Button variant="text" sx={filterLinkTextSx} onClick={() => setState((s) => ({ ...s, useExact: !s.useExact }))}>
                      {state.useExact ? 'Use Time Frame' : 'Use Date Range'}
                    </Button>
                  </Row>
                  {!state.useExact ? (
                    <Select value={daterange} onChange={handleDatesChange} sx={{ mt: 0.5 }}>
                      {DateRanges.map((card, i) => {
                        return (
                          <MenuItem key={`${card.value}-${i}`} value={card.value}>
                            {card.title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : (
                    <Box sx={{
                      maxWidth: 300
                    }}>
                      <DatePicker
                        id="mui-pickers-date_start"
                        label="Start Date"
                        autoOk={true}
                        value={start_date}
                        onChange={handleStartDateChange}
                        sx={filterDatePickerPaddingSx}
                        KeyboardButtonProps={{
                          'aria-label': 'start date',
                        }}
                      />
                      <DatePicker
                        id="mui-pickers-date_end"
                        label="End Date"
                        autoOk={true}
                        value={end_date}
                        onChange={handleEndDateChange}
                        sx={filterDatePickerPaddingSx}
                        KeyboardButtonProps={{
                          'aria-label': 'end date',
                        }}
                      />
                    </Box>
                  )}
                </FormControl>
              </Box>
            )}

            {hasVendors && canShowFilter('vendors') && (
              <Box sx={filterFormGridSx}>
                <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                  <FormLabel htmlFor="Standard-scorecard-simple" sx={filterFormLabelSx}>
                    Company
                  </FormLabel>
                  <Select value={get(client, 'id', 0)} onChange={handleVendorChange}>
                    <MenuItem value={0}>
                      <em>Any</em>
                    </MenuItem>
                    {get(vendors, 'data', [])
                      .sort((a, b) => sortAlphaNum(a, b, 'vendor.name'))
                      .map((vend) => {
                        return (
                          <MenuItem key={`${vend.id}`} value={vend.id}>
                            {get(vend, [prefixToUse, 'name'], '')}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Box>
            )}

            {['data', 'list'].includes(display) && canShowFilter('templates') && (
              <Box sx={filterFormGridSx}>
                <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                  <FormLabel htmlFor="Standard-scorecard-simple" sx={filterFormLabelSx}>
                    Template
                  </FormLabel>
                  <Select value={template_id} onChange={handleTemplateChange}>
                    <MenuItem value={0}>
                      <em>Any</em>
                    </MenuItem>
                    {get(templates, 'data', [])
                      .sort((a, b) => sortAlphaNum(a, b, 'name'))
                      .map((vend) => {
                        return (
                          <MenuItem key={`${vend.id}`} value={vend.id}>
                            {get(vend, 'name', '')}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Box>
            )}

            {display === 'data' && canShowFilter('status') && (
              <>
                <Box sx={filterFormGridSx}>
                  <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                    <FormLabel htmlFor="Standard-scorecard-simple" sx={filterFormLabelSx}>
                      Status

                      <Button style={{ position: 'absolute', right: 0 }} sx={filterLinkTextSx} onClick={toggleCompare}>COMPARE</Button>
                    </FormLabel>
                    <Select value={status || 'active'} onChange={handleStatusChange}>
                      {ReportDataStatus.map((vend) => {
                        return (
                          <MenuItem key={`${vend.value}`} value={vend.value}>
                            {vend.title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>

                  {_showCompare && <CompareSelector filter={thefilter} close={toggleCompare} changeFilter={changeFilter} />}
                </Box>

                {status === 'review' && (
                  <Text type="label_small" italic>
                    Please note that “Review” data only displays for assessments that are “Final”, for access reasons.
                  </Text>
                )}

                <Box sx={filterFormGridSx}>
                  <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                    <Droprealms
                      currentRealm={state.currentRealm}
                      useCurrentChange={false}
                      dontSelectCurrent
                      onCurrentRealm={(r) => setState((s) => ({ ...s, currentRealm: r }))}
                      realms={allrealms}
                      singleTierSelect={false}
                      onUpdate={(selRealms) => updateRealms(selRealms)}
                      showModify={true}
                      showAsFilter={true}
                    />
                  </FormControl>
                </Box>
              </>
            )}

            {display === 'photo' && (
              <>
              <Box sx={filterFormGridSx}>
                <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                  <FormLabel htmlFor="Standard-scorecard-simple" sx={filterFormLabelSx}>
                    Category
                  </FormLabel>
                  <Select value={superset_id || 0} onChange={handleSystemChange}>
                    <MenuItem value={0}>
                      <em>Any</em>
                    </MenuItem>
                    {!!size(supersets.data) &&
                      (supersets.data || []).map((card, i) => {
                        return (
                          <MenuItem key={`${card.id}-${i}`} value={card.id}>
                            {card.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={filterFormGridSx}>
                <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                  <FormLabel htmlFor="Standard-scorecard-simple" sx={filterFormLabelSx}>
                    Author
                  </FormLabel>
                  <Select value={user_id || 0} onChange={handleAuthorChange}>
                    <MenuItem value={0}>
                      <em>Any</em>
                    </MenuItem>
                    {!!size(users.data) &&
                      users.data.map((u, i) => {
                        return (
                          <MenuItem key={`${u.id}-${i}`} value={u.id}>
                            {u.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={filterFormGridSx}>
                <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                  <FormLabel htmlFor="Standard-scorecard-simple" sx={filterFormLabelSx}>
                    Quality
                  </FormLabel>
                  <Select value={quality_type} onChange={handleQualityChange}>
                    {QualityType.map((qt) => (
                      <MenuItem key={qt.value} value={qt.value}>
                        {qt.value === 1 ? <em>{qt.title}</em> : qt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              {_photoSource === 'highlights' && (
                <>
                  <Box sx={filterFormGridSx}>
                    <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                      <FormLabel sx={filterFormLabelSx}>
                        Highlight Type
                      </FormLabel>
                      <Select displayEmpty value={section_type ?? ''} onChange={handleSectionTypeChange}>
                        {HighlightSectionType.map((opt) => (
                          <MenuItem key={`${opt.value}`} value={opt.value ?? ''}>
                            {opt.value == null ? <em>{opt.title}</em> : opt.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={filterFormGridSx}>
                    <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
                      <FormLabel sx={filterFormLabelSx}>
                        Template
                      </FormLabel>
                      <Select displayEmpty value={template ?? ''} onChange={handleHighlightTemplateChange}>
                        {HighlightTemplate.map((opt) => (
                          <MenuItem key={`${opt.title}`} value={opt.value ?? ''}>
                            {opt.value == null ? <em>{opt.title}</em> : opt.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </>
              )}
              </>
            )}
          </Stack>
        </form>
      </DiagContainer>
    </Box>
  );
}

const CompareSelector = props => {
  const { filter } = props;
  const { compareStatus, compareType } = filter;

  const handleStatusChange = e => {
    props.changeFilter(set({ ...filter }, 'compareStatus', e.target.value));
  }

  const handleTypeChange = e => {
    props.changeFilter(set({ ...filter }, 'compareType', e.target.value));
  }

  return (
    <Box sx={filterCompareRowSx}>
      <IconButton sx={filterCompareCloseSx} size="small" color="secondary" onClick={props.close}><Icon>close</Icon></IconButton>

      <div style={{ width: '100%' }}>
        <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
          <FormLabel sx={filterFormLabelSx}>
            Compare to Status
          </FormLabel>
          <Select value={compareStatus || 'active'} onChange={handleStatusChange}>
            {ReportDataStatus.map((vend) => {
              return (
                <MenuItem key={`${vend.value}`} value={vend.value}>
                  {vend.title}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <FormControl variant="standard" sx={[filterFormItemSx, filterFormControlPaddingSx]}>
          <FormLabel sx={filterFormLabelSx}>
            Compare Type
          </FormLabel>
          <Select value={compareType || 'diff'} onChange={handleTypeChange}>
            {CompareTypes.map((qt) => (
              <MenuItem key={qt.value} value={qt.value}>{qt.value === 1 ? <em>{qt.title}</em> : qt.title}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </Box>
  )
}